import React from 'react';
import YoutubeVideo from './YoutubeVideo';
import './youtubevideo.css';

const youtubelist = (props) => {
  const renderedCourses = props.courses.map((course) =>{
      return <YoutubeVideo key={course.id.videoId} onCourseSelect={props.onCourseSelect} course={course} />
  });

  return(
      <div className="ui relaxed divided list video-list">{renderedCourses}</div>
  )
}

export default youtubelist;